module.exports = __webpack_public_path__ + "img/org_delete.260a3d17.svg";